import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import DetailToolBar from '../fw/DetailToolBar.react.js';
import DetailBox from '../fw/DetailBox.react.js';
import TableDetail from '../fw/TableDetail.react';
import DeleteButton from '../fw/DeleteButton.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'relationDefView.title', 'defaultMessage': 'Relation definition'}
});

interface RelationDefViewProps {
    intl: IntlShape;
    user: User;
}

class RelationDefView extends React.Component<RelationDefViewProps> {

    typeName = 'relationDefs';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();
    }

    render() {
        const data = this.props.user.organisation.relationDef;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <DetailBox data={data} metadata={type} urlMapping={urlMapping}>
                    <DetailToolBar data={data} metadata={type} organisationId={this.props.user.organisation.realId} urlMapping={urlMapping}>
                        <DeleteButton
                            data={data}
                            deleteFatQuery={Relay.QL `fragment on DeleteRelationDefPayload {
                                                            updatedNode {
                                                                id
                                                            },
                                                            organisation {
                                                                relationDefs(first: 2000) {
                                                                    edges {
                                                                        node {
                                                                            id
                                                                        }
                                                                    }
                                                                }
                                                            }

                                                        }`}
                            deleteMutation={Relay.QL `mutation { deleteRelationDef }`}
                            metadata={type}
                            organisationId={this.props.user.organisation.realId}
                            types={types}
                            urlMapping={urlMapping}
                        />
                    </DetailToolBar>

                    <h2>{data.name} {data.fromChannel ? (data.fromChannel.name ? data.fromChannel.name : data.fromChannel.channelDef.name) : null} -&gt; {data.toChannel ? (data.toChannel.name ? data.toChannel.name : data.toChannel.channelDef.name) : null} </h2>

                    <TableDetail columns={['type', 'description', 'fromChannel.name', 'fromChannel.channelDef.name', 'fromEntity.name', 'fromField.name', 'toChannel.name', 'toChannel.channelDef.name', 'toEntity.name', 'toField.name']} data={data} metadata={type} />
                </DetailBox>
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(RelationDefView), (props) => {
    return props.user.organisation && props.user.organisation.relationDef;
}), {
    initialVariables: {
        organisationId: '',
        relationDefId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    relationDef(id: $relationDefId) {
                        organisation_id,
                        id,
                        name,
                        type,
                        description,
                        fromChannel {
                            id,
                            name,
                            channelDef {
                                id,
                                name
                            }
                        },
                        toChannel {
                            id,
                            name,
                            channelDef {
                                id,
                                name
                            }
                        },
                        fromEntity {
                            id,
                            name,
                        },
                        toEntity {
                            id,
                            name,
                        },
                        fromField {
                            id,
                            name
                        },
                        toField {
                            id,
                            name
                        }
                    }
                }
            }
        `,
    },
});
